import messages from '@/i18n/locales/messages';
import { createI18n } from 'vue-i18n';

export const i18nParams = {
    legacy: false,
    locale: 'it',
    fallbackLocale: 'it',
    messages: messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true
}
export const i18n = createI18n( i18nParams );
export const i18nGlobal = i18n.global

